import styled from "styled-components";
import { media } from '../config/helpers/queries/media';

export const RoutesWrapper = styled.div`
display: flex;
justify-content: space-between;
align-content: center;

.agreement {
  width: 100%;
  height: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

//.shadow-layout {
//  @media (min-width: 576px) {
//    position: absolute;
//    top: 0;
//    right: 0;
//    bottom: 0;
//    width: calc(100% - 288px);
//    background: rgba(0, 0, 0, 0.6);
//    z-index: 2;
//  }
//}
//
//&.opened {
//  @media (max-width: 576px) {
//    .layout-scroll {
//      .os-scrollbar-handle {
//        display: none;
//      }
//
//      .dashboard-inner {
//        .os-scrollbar-handle {
//          display: block;
//        }
//      }
//    }
//
//    .scroll-top-button {
//      z-index: 0;
//    }
//  }
`;

export const StepsWrapper = styled.div`
  max-width: 900px;
  background-color: #fff;
  ${'' /* box-shadow: 0 4px 8px rgb(230 0 15 / 24%), */}
  ${'' /* inset 0 -1px 0 rgb(182 187 200 / 25%); */}
  padding: 30px 33px 20px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  -webkit-animation: slideIn 0.65s ease-out forwards;
  ${'' /* animation: slideIn 0.65s ease-out forwards; */}
  border-radius: 20px;
  width: 100%;
  @-webkit-keyframes animate {
    100% {
      transform: translateX(0);
    }
  }
  @keyframes animate {
    100% {
      transform: translateX(0);
    }
  }

  .btnsWrapper {
    display: flex;
    flex-wrap: nowrap !important;
    gap: 6px;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    width: auto;
    height: 110px;
    border-top: 1px solid lightGrey;
    border-bottom: 1px solid lightGrey;
    padding: 16px 0px;

    
    position: relative;

    ${media.desktop`
      display: flex; 
      // grid-template-columns: repeat(6, 1fr);
    `}
  }

  .content {
    margin-top: 40px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }

  .bottom {
    display: flex;
    align-content: center;
    justify-content: center;

    ${media.desktop`
      ustify-content: end;
    `}

    & button {
      margin-right: 20px;
    }
  }

  .right {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    animation: slideIn 0.65s ease-out forwards;
    @-webkit-keyframes slideIn {
      100% {
        -webkit-transform: translateX(0%);
      }
    }
    @keyframes slideIn {
      100% {
        transform: translateX(0%);
      }
    }
  }
`;